// Admin API utilities - FIXED VERSION
const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const adminApi = {
  // Auth
  checkInit: async () => {
    const res = await fetch(`${API_BASE}/api/admin/check-init`);
    return res.json();
  },

  setup: async (email, password, confirmPassword) => {
    const res = await fetch(`${API_BASE}/api/admin/setup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password, confirm_password: confirmPassword })
    });
    
    const text = await res.text();
    const data = text ? JSON.parse(text) : {};
    
    if (!res.ok) {
      throw new Error(data.detail || 'Setup failed');
    }
    
    return data;
  },

  login: async (email, password) => {
    const res = await fetch(`${API_BASE}/api/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password })
    });
    
    const text = await res.text();
    const data = text ? JSON.parse(text) : {};
    
    if (!res.ok) {
      throw new Error(data.detail || 'Login failed');
    }
    
    return data;
  },

  logout: async () => {
    const res = await fetch(`${API_BASE}/api/admin/logout`, {
      method: 'POST',
      credentials: 'include'
    });
    return res.json();
  },

  checkSession: async () => {
    const res = await fetch(`${API_BASE}/api/admin/session`, {
      credentials: 'include'
    });
    if (!res.ok) throw new Error('Not authenticated');
    return res.json();
  },

  updatePreferences: async (language) => {
    const res = await fetch(`${API_BASE}/api/admin/preferences`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ language })
    });
    return res.json();
  },

  // Dashboard
  getDashboard: async (startDate, endDate) => {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    
    const res = await fetch(`${API_BASE}/api/admin/dashboard/overview?${params}`, {
      credentials: 'include'
    });
    return res.json();
  },

  // Users
  getUsers: async (page = 1, limit = 50, search = '') => {
    const params = new URLSearchParams({ page, limit });
    if (search) params.append('search', search);
    
    const res = await fetch(`${API_BASE}/api/admin/users?${params}`, {
      credentials: 'include'
    });
    return res.json();
  },

  getUserDetail: async (userId) => {
    const res = await fetch(`${API_BASE}/api/admin/users/${userId}`, {
      credentials: 'include'
    });
    return res.json();
  },

  // Analytics
  getAnalyticsSummary: async (days = 30) => {
    const res = await fetch(`${API_BASE}/api/admin/analytics/summary?days=${days}`, {
      credentials: 'include'
    });
    return res.json();
  },

  // Export
  exportUsers: async (format = 'csv') => {
    const res = await fetch(`${API_BASE}/api/admin/export/users?format=${format}`, {
      credentials: 'include'
    });
    
    if (format === 'json') {
      return res.json();
    }
    
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `users_export.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  },

  // System Health
  getSystemHealth: async () => {
    const res = await fetch(`${API_BASE}/api/admin/system/health`, {
      credentials: 'include'
    });
    return res.json();
  }
};
